<template>
  <div id="auth-layout">
    <SidebarV2></SidebarV2>
    <div class="main-wrapper">
      <Topbar></Topbar>
      <main>
        <Suspense>
          <router-view v-slot="{ Component, route }">
            <transition mode="out-in" name="fade">
              <div :key="route.path">
                <component :is="Component" :id="route.name" />
              </div>
            </transition>
          </router-view>
        </Suspense>
      </main>
    </div>
    <NewsModal v-if="!!appStore.currentNews" :is-open="!!appStore.currentNews" :title="appStore.currentNews.title" :text="appStore.currentNews.text" @close="appStore.dismissNews" :video="appStore.currentNews.video" />
  </div>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import { reactive, onMounted, watch, inject } from "vue";

import { useAppStore } from "@/stores/app.js";
import { getImage } from "@/composables/getImage.js";

import { useUser } from "@/queries/user.query";
import { useOrganisation } from "@/queries/organisation.query";

import NewsModal from "@/components/modals/app/NewsModal.vue";
import SidebarV2 from "@/components/sidebarV2/SidebarV2.vue";
import Topbar from "@/components/topbar/Topbar.vue";

const route = useRoute();

const crisp: any = inject("crisp");

const appStore = useAppStore();

const { data: user, isPending: isUserPending } = useUser();
const { data: organisation, isPending: isOrganisationPending } = useOrganisation();

const state = reactive({
  isMobile: false,
});

const currentVersion = ref(null)

async function checkVersion() {
  const res = await fetch('/version.json');
  const data = await res.json();

  if (currentVersion.value && currentVersion.value !== data.version) {
    window.location.reload();
  }

  axiosInstance.defaults.headers.common['x-app-version'] = data.version; // Add the version to the headers
  currentVersion.value = data.version;
}

watch(route, () => {
  state.isMobile ? appStore.toggleSidebar(false) : null;
});

onMounted(async () => {
  checkVersion();
  setInterval(checkVersion, 5000); // check every 5s

  state.isMobile = window.innerWidth <= 1100;

  window.addEventListener("resize", () => {
    state.isMobile = window.innerWidth <= 1100;
  });
});

watch(
  isOrganisationPending,
  (isPending) => {
    if (!isPending) {
      crisp.session.setSegments(["Recruteur"]);
      crisp.user.setEmail(user.value.personal_information.email);
      crisp.user.setNickname(`${user.value.personal_information.first_name} ${user.value.personal_information.last_name}`);
      crisp.user.setCompany(organisation.value?.details?.name);

      if (user.value.personal_information.profile_picture_id) {
        crisp.user.setAvatar(getImage(user.value.personal_information.profile_picture_id));
      }

      crisp.session.setData({
        user_id: user.value.id,
      });
    }
  }
);

</script>
